import * as React from 'react';
import Box from '@mui/material/Box';
import { Alert, AlertTitle } from '@mui/material';
import { NotificationModel } from '../../../NotificationModel';

interface myProps {
    notification : NotificationModel
}

export const MyAlert : React.FC<myProps> = (props: myProps)=> {
    const [open, setOpen] = React.useState(true);
    React.useEffect(() => {
        if (open) {
            const timer = setTimeout(() => {
                setOpen(false);
            }, 3000);
            return () => clearTimeout(timer);
        }

    }, [open]);

    return (
        <Box sx={{ width: '100%' }}>
            <Alert severity={props.notification.severity ? props.notification.severity : 'success'}>
                <AlertTitle>{props.notification.title}</AlertTitle>
                {props.notification.message}
            </Alert>
        </Box>
    );
}
